// Role ids as returned by GET /current-user (roleId is a string, e.g. "1").
export const ROLES = {
  ADMIN: "1",
  MANAGER: "3",
  EMPLOYEE: "4",
};

// Route names making up "اعدادات النظام" (System Settings) — the single page
// under the "settings" section that MANAGER may not access. Everything else
// in that section (e.g. currencies) stays available to them.
const SYSTEM_SETTINGS_ROUTE_NAMES = ["system-settings", "record_system"];

// The only pages an EMPLOYEE may access: reservations + un-completed reservations.
const EMPLOYEE_ALLOWED_ROUTE_NAMES = [
  "reservations_record",
  "ReservationDetails",
  "reservations_un_comp_record",
  "ReservationUnCompDetails",
];
const EMPLOYEE_ALLOWED_TOP_LEVEL_TITLES = ["reservations", "reservations-un-comp"];

// Filters the sidebar's route tree (asyncRoutes shape) for the given role.
export function filterRoutesByRole(routes, roleId) {
  if (roleId === ROLES.ADMIN) return routes;

  if (roleId === ROLES.EMPLOYEE) {
    return routes.filter((route) => EMPLOYEE_ALLOWED_TOP_LEVEL_TITLES.includes(route.meta && route.meta.title));
  }

  if (roleId === ROLES.MANAGER) {
    return routes.map((route) => {
      if (!route.children || (route.meta && route.meta.title) !== "settings") return route;
      return {
        ...route,
        children: route.children.filter((child) => !SYSTEM_SETTINGS_ROUTE_NAMES.includes(child.name)),
      };
    });
  }

  return [];
}

// Checks whether a navigation target is reachable for the given role.
// Non-app routes (login/401/404, not nested under the "layout" route) are
// always reachable so this can't create a redirect loop.
export function isNavigationAllowedForRole(to, roleId) {
  const matchedNames = to.matched.map((record) => record.name).filter(Boolean);
  if (!matchedNames.includes("layout")) return true;

  if (roleId === ROLES.ADMIN) return true;

  if (roleId === ROLES.EMPLOYEE) {
    return matchedNames.some((name) => EMPLOYEE_ALLOWED_ROUTE_NAMES.includes(name));
  }

  if (roleId === ROLES.MANAGER) {
    return !SYSTEM_SETTINGS_ROUTE_NAMES.some((name) => matchedNames.includes(name));
  }

  return false;
}

// Where to land a role right after login.
export function getDefaultRouteForRole(roleId) {
  if (roleId === ROLES.EMPLOYEE) return "/reservations";
  return "/dashboard";
}
